// components/ProfileQuestions.jsx
import React from 'react';

const ProfileQuestions = ({ questions }) => {
  if (!questions || questions.length === 0) return null;

  return (
    <>
      <div>
        <h3 className="pt-3">My 5 questions to mentors?</h3>
      </div>
      {questions.map((item, index) => (
        <span>
          <div className="mentor-question"> {` ${index + 1}. Question to mentors`}</div>
          <div className="ps-3 fw-normal">{item.question}</div>
          <br></br>
        </span>
      ))}
    </>
  );
};

export default ProfileQuestions;
